// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Offers_body__19pv6 {
  display: flex;
  justify-content: space-between;
}
.Offers_body__19pv6 p {
  margin: 0;
}
.Offers_body__19pv6 Button {
  margin-top: 16px;
  width: 100%;
}

.Offers_options-subtitle__7Ur47.Offers_options-subtitle__7Ur47 {
  margin-bottom: 15px;
  font-size: 14px;
  padding-top: 6px;
  color: #808080;
}

.Offers_options__zmlvZ {
  width: 40%;
}

.Offers_option-detail__bmQsm {
  width: 58%;
}

.Offers_info__Q8oBm {
  margin-bottom: 24px;
}

.Offers_info-subtitle__MJ5Db.Offers_info-subtitle__MJ5Db {
  margin-top: -55px;
}

.Offers_no-option-wrapper__7vGHV {
  margin: 40px auto;
  width: -moz-fit-content;
  width: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.Offers_no-option-message__9mwao {
  color: #808080;
  font-weight: bold;
}

.Offers_image__MAwA- {
  width: 330px;
}

.Offers_red-text__QKSv9 {
  font-size: 12px;
  color: red;
}

.Offers_blue-text__E8hHX {
  font-size: 12px;
  color: blue;
}

.Offers_subsection-title__zbn0J.Offers_subsection-title__zbn0J {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
}

.Offers_actions__0bcVT {
  margin-top: 24px;
  display: flex;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/views/Offers/Offers.module.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,8BAAA;AAAF;AACE;EACE,SAAA;AACJ;AACE;EACE,gBAAA;EACA,WAAA;AACJ;;AAGA;EACE,mBAAA;EACA,eCdO;EDeP,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,UAAA;AAAF;;AAGA;EACE,UAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,cAAA;EACA,iBAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,eAAA;EACA,UAAA;AAAF;;AAGA;EACE,eAAA;EACA,WAAA;AAAF;;AAGA;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;AAAF","sourcesContent":["@use \"styles/typography\";\n.body {\n  display: flex;\n  justify-content: space-between;\n  p {\n    margin: 0;\n  }\n  Button {\n    margin-top: 16px;\n    width: 100%;\n  }\n}\n\n.options-subtitle.options-subtitle {\n  margin-bottom: 15px;\n  font-size: typography.$body-m;\n  padding-top: 6px;\n  color: #808080;\n}\n\n.options {\n  width: 40%;\n}\n\n.option-detail {\n  width: 58%;\n}\n\n.info {\n  margin-bottom: 24px;\n}\n\n.info-subtitle.info-subtitle {\n  margin-top: -55px;\n}\n\n.no-option-wrapper {\n  margin: 40px auto;\n  width: fit-content;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.no-option-message {\n  color: #808080;\n  font-weight: bold;\n}\n\n.image {\n  width: 330px;\n}\n\n.red-text {\n  font-size: 12px;\n  color: red;\n}\n\n.blue-text {\n  font-size: 12px;\n  color: blue;\n}\n\n.subsection-title.subsection-title {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 20px;\n}\n\n.actions {\n  margin-top: 24px;\n  display: flex;\n  justify-content: space-between;\n}\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `Offers_body__19pv6`,
	"options-subtitle": `Offers_options-subtitle__7Ur47`,
	"options": `Offers_options__zmlvZ`,
	"option-detail": `Offers_option-detail__bmQsm`,
	"info": `Offers_info__Q8oBm`,
	"info-subtitle": `Offers_info-subtitle__MJ5Db`,
	"no-option-wrapper": `Offers_no-option-wrapper__7vGHV`,
	"no-option-message": `Offers_no-option-message__9mwao`,
	"image": `Offers_image__MAwA-`,
	"red-text": `Offers_red-text__QKSv9`,
	"blue-text": `Offers_blue-text__E8hHX`,
	"subsection-title": `Offers_subsection-title__zbn0J`,
	"actions": `Offers_actions__0bcVT`
};
export default ___CSS_LOADER_EXPORT___;
